import { getDeviceLocale } from "@cabocheck/shared";
import type { LoaderFunctionArgs } from "react-router";
import { useLoaderData } from "react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ProductsHeader } from "~/features/microsite/ProductsHeader";
import { TestOffersComponent } from "~/features/microsite/TestOffers";
import { PublicFooter } from "~/features/public/Footer";
import { MedicalTestProfileBox } from "~/features/tests/MedicalTestProfileBox";
import { loadProducts } from "~/utils/apis/loadProducts.server";

export async function loader({ request }: LoaderFunctionArgs) {
  const device_locale = getDeviceLocale(request);
  const products = await loadProducts(device_locale);

  return {
    products,
  };
}

export default function KundeProducts() {
  const { t } = useTranslation();
  const data = useLoaderData<typeof loader>();
  const [filter, setFilter] = useState("");

  return (
    <div id="angebot" className="relative font-open-sans antialiased">
      <div className="h-28" />
      <TestOffersComponent
        header={<ProductsHeader filter={filter} setFilter={setFilter} />}
        products={data.products
          ?.filter((p) => p.name.toLowerCase().includes(filter.toLowerCase()))
          .map((p) => (
            <MedicalTestProfileBox
              key={p.medical_test_profile_guid}
              to={`${p.name}`}
              panel={{
                name: p.name,
                subline: p.subline,
                medical_tests: p.medical_tests,
              }}
            />
          ))}
        emptyContent={filter ? <p className="text-center text-gray-600">{t("Keine Daten gefunden")}</p> : undefined}
      />
      <PublicFooter />
    </div>
  );
}
